import React, { Suspense } from 'react';
import { TopBarBase } from 'shared/components/connected/top-bar-base';

import { Interactions, LoadingInteractions } from './interactions';
import * as Styled from './page-top-bar.style';
import { LoadingTitle, Title } from './title';

export const PageTopBar: React.FC = () => (
  <TopBarBase>
    <Styled.Content>
      <Suspense fallback={<LoadingTitle />}>
        <Styled.Title>
          <Title />
        </Styled.Title>
      </Suspense>

      <Suspense fallback={<LoadingInteractions />}>
        <Interactions />
      </Suspense>
    </Styled.Content>
  </TopBarBase>
);
